import React from "react";
import Container from "ui/Container/Container";
import Button from "ui/Button/Button";
import styles from "./Content.module.scss";

type Props = {
  statusCode?: number;
  requestTraceId?: string;
};

const Content: React.FC<Props> = ({ statusCode, requestTraceId }) => {
  const onReload = () => {
    document.location.reload();
  };

  const traceId = requestTraceId;

  return (
    <Container>
      <div className={styles.content}>
        <h1 className={styles.contentTitle}>
          Ошибка {statusCode ? statusCode : ""}
        </h1>
        <p className={styles.contentText}>
          Ошибка на&nbsp;сервере. Мы&nbsp;работаем над решением проблемы.
          Попробуйте обновить страницу через&nbsp;пару&nbsp;минут
        </p>
        {traceId && <p className={styles.contentTrace}>trace-id: {traceId}</p>}
        <Button onClick={onReload} orange fluid>
          Обновить страницу
        </Button>
      </div>
    </Container>
  );
};

export default Content;
